import * as z from 'zod';
import { CreditRoleEnum } from '@soundxyz/utils/const';
import { addressSchema } from '@soundxyz/utils/constants/schema';
import { SplitsErrors } from './errors';

export const MultiSelectOptionSchema = z.array(
  z.object({
    label: z.string(),
    value: z.string(),
  }),
);

export const Split = z.object({
  ownerAddress: z.string(),
  percent: z.union([z.string(), z.number()]),
  roles: z.array(z.nativeEnum(CreditRoleEnum)),
});

export type Split = (typeof Split)['_input'];

export const SplitFieldOptions = Split.keyof().options;

export type SplitFieldOptionsType = (typeof SplitFieldOptions)[number];

export const SplitsFields = z.object({
  splitContractAddress: addressSchema.nullable(),
  splits: z.array(Split),
});

export type SplitsFields = (typeof SplitsFields)['_input'];

export const SplitsTouchedFields = z.object({
  splits: z.boolean(),
});

export type SplitsTouchedFields = (typeof SplitsTouchedFields)['_input'];

export const SplitsSchema = z.object({
  fields: SplitsFields,
  touched: SplitsTouchedFields,
  errors: SplitsErrors,
  isValid: z.boolean(),
});

export type SplitsState = (typeof SplitsSchema)['_input'];
